// extracted by mini-css-extract-plugin
export default {"crudButton":"styles_crudButton__fhaTb"};